import { useContext } from 'react'
import DeepAnalysisPeriodContext from '../../StateManagment/DeepAnalysisPeriodContext'
import DeepAnalysisComparePanes from './DeepAnalysisComparePanes'

/**
 * Context card at the top of a deep-analysis page (redesign): a two-pane
 * card with a short "about" text on the left and a facts list on the right.
 * The facts pane is a slot — the indicator data layer portals the
 * Onderzoek / Meetmoment / Vragenlijst / Antwoorden rows into it via
 * DeepAnalysisSlotsContext, so the data fetching stays where it is.
 *
 * @param {object} props
 * @param {string} props.aboutTitle - Heading of the about pane, e.g. 'Over dit effect'
 * @param {string} [props.aboutText] - Description of the anchor entity; pane is hidden when empty
 * @param {(el: HTMLElement|null) => void} props.setFactsEl - Ref callback registering the facts pane as portal target
 * @param {(el: HTMLElement|null) => void} [props.setFactsElB] - Ref callback for the compare period's facts pane; when the page compares two periods the card shows two labelled panes
 */
const DeepAnalysisContextCard = ({ aboutTitle, aboutText, setFactsEl, setFactsElB }) => {
    const period = useContext(DeepAnalysisPeriodContext)
    const compare = Boolean(period?.compareActive && setFactsElB)

    return (
        <div className={`deep-analysis-section deep-analysis-context${aboutText ? '' : ' deep-analysis-context--facts-only'}`}>
            {aboutText && (
                <div className='deep-analysis-context-about'>
                    <h4>{aboutTitle}</h4>
                    <p>{aboutText}</p>
                </div>
            )}
            {compare ? (
                <DeepAnalysisComparePanes
                    rangeA={period.rangeA}
                    rangeB={period.rangeB}
                    setElA={setFactsEl}
                    setElB={setFactsElB}
                    paneClassName='deep-analysis-context-facts'
                />
            ) : (
                <div className='deep-analysis-context-facts' ref={setFactsEl} />
            )}
        </div>
    )
}

export default DeepAnalysisContextCard
